// AUTO-GENERATED from docs/docs/fastlane/user-support/fastlane-user-manual-combined.md.
// Do not edit by hand. Re-run scripts/generate-user-guide-sections.py.


import type { Section } from "../../types";
import quick_startSection from "./quick-start";
import ordersSection from "./orders";
import production_queuesSection from "./production-queues";
import materialSection from "./material";
import ballooningSection from "./ballooning";
import machinesSection from "./machines";
import workholding_versabuiltSection from "./workholding-versabuilt";
import quality_gagesSection from "./quality-gages";
import schedulingSection from "./scheduling";
import administrationSection from "./administration";
import changelogSection from "./changelog";

export const MAIN_SECTIONS: Section[] = [
	quick_startSection,
	ordersSection,
	production_queuesSection,
	materialSection,
	ballooningSection,
	machinesSection,
	workholding_versabuiltSection,
	quality_gagesSection,
	schedulingSection,
	administrationSection,
	changelogSection,
];
